import { render, staticRenderFns } from "./BaseNotificator.vue?vue&type=template&id=4049c00d"
import script from "./BaseNotificator.vue?vue&type=script&lang=js"
export * from "./BaseNotificator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports